<template>
  <div>
    <core-grid ref="grid" :onRead="onRead" :schema="schema"> </core-grid>
    <ParceiroTalkTelecomEdit
      ref="editar"
      @close="response"
    ></ParceiroTalkTelecomEdit>
  </div>
</template>

<script>
export default {
  components: {
    ParceiroTalkTelecomEdit: () => import('./ParceiroTalkTelecomEdit')
  },
  data () {
    return {
      show: true,
      model: {},
      ID: '',
      schema: [
        { value: 'urlBase', text: 'Url Base' },
        { value: 'userTalk', text: 'Usuário Talk' }
      ]
    }
  },
  methods: {
    onRead: function (options, search) {
      if (search === null || search === '') { search = '' }
      this.$api.SmsTalkTelecom.Get('GetAll').then(function (response) {
        options.success(response)
      })
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) {
        this.refresh()
      }
    },
    openModal (sender) {
      const th = this
      th.show = true
      th.model = {}
      if (sender) {
        th.model = sender
        th.ID = th.model.id
      } else th.ID = ''
    },
    excluir (current) {
      const th = this
      if (current) {
        th.$api.SmsTalkTelecom.Delete(current.id).then(function (data) {
          if (th.$api.UI.PostAction(data, `${current.id} removido com sucesso.`)) {
            th.refresh()
          }
        })
      }
    }
  }
}
</script>
